module.exports = __webpack_public_path__ + "src/img/humtasks.ccfdce4402c6ffac77715079a7d157c8.png";